import { setAddNewCardModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import Spinner from '../../../../../components/Spinner';
import { PlusIcon } from '../../../../../assets/icons';
import Card from '../../components/Card';
import styles from './style.module.scss';
import {
    selectPaymentMethods,
    selectFetchingPaymentMethods,
} from '../../../../../store/workspace/selectors';

/** "Your cards" pane: every card Stripe has on file for this customer. */
export default function PaymentMethods() {
    const dispatch = useDispatch();
    const paymentMethods = useSelector(selectPaymentMethods);
    const fetching = useSelector(selectFetchingPaymentMethods);

    return (
        <div className={styles.wrapper}>
            {!fetching && paymentMethods.length === 0 && <span className={styles.empty}>
                You didn’t add any cards.
            </span>}

            {!fetching && paymentMethods.map(method =>
                <Card key={method.id} paymentMethod={method} />)}

            {fetching && <Spinner />}

            <div
                className={styles.add_new_card}
                onClick={() => dispatch(setAddNewCardModal(true))}
            >
                <PlusIcon />
                <span>Add new credit or debit card</span>
            </div>
        </div>
    );
};
